export default {
  props: {
    // 组件名称
    componentName: {
      default: '',
      type: String,
    },
    // 组件类型
    componentType: {
      default: 0,
      type: Number,
    },
    // 组件标题
    componentTitle: {
      default: '',
      type: String,
    },
    // 栏目标题
    title: {
      default: '',
      type: String,
    },
    // 栏目介绍
    describe: {
      default: '',
      type: String,
    },
    // 按钮名称
    buttonName: {
      default: '',
      type: String,
    },
    // 按钮链接
    buttonUrl: {
      default: '',
      type: String,
    },
    // 内容项列表
    dataList: {
      default: () => [],
      type: Array,
    },
    // 0 自定义跳转 1功能性跳转
    skipType: {
      default: 0,
      type: Number,
    },
    // 0 预约诊断  1分诊台跳转
    functionType: {
      default: 0,
      type: Number,
    },
    triageComponentId: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      curIndex: 0,
      showVideo: false,
      videoOptions: {
        autoplay: true,
        controls: true,
        playsinline: true,
        sources: [
          {
            src: this.dataList[0].videoUrl,
            type: 'video/mp4',
          },
        ],
      },
    }
  },
  computed: {
    isLogin() {
      return this.$store.state.ucenter.isLogin
    },
  },
  methods: {
    handleToPlay(index = 0) {
      console.log('popup中的handleToPlay', index, this.dataList[index])
      if (this.dataList[index]?.videoType === 'youtube') {
        this.youtubeVideoUrl = this.dataList[index].videoUrl;
        this.$refs.youtubeVideoRef.handleOpen(this.dataList[index].videoUrl);
      } else {
        this.$refs.videoPopup.handleOpen(this.dataList[index].videoUrl);
      }
      this.cardTrackReport()
    },
    changeSwiperIndex(idx) {
      this.curIndex = idx
    },
  },
}
